<template>
  <el-menu :collapse="isCollapsed" :collapse-transition="false">
    <el-menu-item-group :title="$t('navGroupHeadlineCampaigns')">
      <el-menu-item
        v-for="item in items"
        :key="item.id"
        :class="{ 'is-active--custom': $route.path.includes(item.id) }"
        @click="onClickItem(item)"
      >
        <span slot="title">{{ item.title }}</span>
        <i class="material-icons m-r-1">folder</i>
      </el-menu-item>
    </el-menu-item-group>
  </el-menu>
</template>

<script>
import { TEMPLATE_CATEGORY_DESIGNS } from '@/router/route-types';

export default {
  name: 'AppNavigationCategories',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    isCollapsed() {
      return this.$store.state.menu.collapse;
    }
  },

  methods: {
    onClickItem(item) {
      const { id } = item;
      if (id) {
        this.$router.push({ name: TEMPLATE_CATEGORY_DESIGNS, params: { id } });
      }
    }
  }
};
</script>
